import * as React from "react";
const SvgFiRrFaceNoseSteam = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-nose-steam_svg__a)">
      <path
        fill="#062147"
        d="M0 12C0 5.383 5.383 0 12 0s12 5.383 12 12a1 1 0 1 1-2 0c0-5.514-4.486-10-10-10S2 6.486 2 12a1 1 0 1 1-2 0m12.911 9.959c-.6.053-1.223.053-1.822 0a1 1 0 1 0-.178 1.992 12 12 0 0 0 2.178 0 1 1 0 0 0 .907-1.085.99.99 0 0 0-1.085-.907m3.888-16.938c-1.218.25-2.656 1.196-3.581 2.356a1 1 0 0 0 1.564 1.246c.634-.795 1.65-1.486 2.419-1.644a.999.999 0 1 0-.403-1.959zm-9.598 0a1 1 0 1 0-.403 1.959c.769.157 1.785.849 2.419 1.644a1 1 0 0 0 1.405.159 1 1 0 0 0 .159-1.405C9.856 6.218 8.418 5.272 7.2 5.022zM11 11a1 1 0 0 0-1-1H7a1 1 0 1 0 0 2h3a1 1 0 0 0 1-1m7 0a1 1 0 0 0-1-1h-3a1 1 0 1 0 0 2h3a1 1 0 0 0 1-1m-8.809 3.053c-1.331.595-3.06 1.392-4.417 2.098C4.453 15.479 3.795 15 3 15a2 2 0 0 0-1.657 3.12A1.993 1.993 0 0 0 2 22c.017 0 .033-.005.05-.005a2.5 2.5 0 0 0 4.9 0c.017 0 .033.005.05.005a2 2 0 0 0 .422-3.953 242 242 0 0 0 2.454-3.121c.365-.471-.141-1.116-.685-.873m13.466 4.067A2 2 0 0 0 21 15c-.795 0-1.453.479-1.774 1.151-1.357-.707-3.086-1.504-4.417-2.098-.544-.243-1.049.401-.685.872.728.94 1.637 2.103 2.454 3.121A2 2 0 0 0 17 21.999c.017 0 .033-.005.05-.005a2.5 2.5 0 0 0 4.9 0c.017 0 .033.005.05.005a2 2 0 0 0 2-2c0-.873-.563-1.608-1.343-1.88z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-nose-steam_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceNoseSteam;
